import { render, staticRenderFns } from "./VehiclesCross.vue?vue&type=template&id=26f06056&scoped=true"
import script from "./VehiclesCross.vue?vue&type=script&lang=js"
export * from "./VehiclesCross.vue?vue&type=script&lang=js"
import style0 from "./VehiclesCross.vue?vue&type=style&index=0&id=26f06056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f06056",
  null
  
)

export default component.exports